import Step4 from "./Step4";
import Step5 from "./Step5";
import Step6 from "./Step6";
import Step7 from "./Step7";

const GroupedStep2 = ({
  setText,
  text,
  validateIsErr,
  disabled = false,
  deliveryInfo,
  deliveryLoading,
  deliveryError,
  onRequestDeliveryAddress,
  formToShow,
}) => {

  const shouldShowStep = (stepIndex) => {
    return formToShow?.some(
      (step) => step.Index === stepIndex && step.IsActivated
    );
  };

  return (
    <>
      {shouldShowStep(4) && (
        <Step4
          setText={setText}
          text={text}
          disabled={disabled}
          validateIsErr={validateIsErr}
        />
      )}

      {shouldShowStep(5) && (
        <Step5
          setText={setText}
          text={text}
          validateIsErr={validateIsErr}
        />
      )}

      {shouldShowStep(6) && (
        <Step6
          setText={setText}
          text={text}
          validateIsErr={validateIsErr}
        />
      )}

      {shouldShowStep(7) && (
        <Step7
          setText={setText}
          text={text}
          validateIsErr={validateIsErr}
          deliveryInfo={deliveryInfo}
          deliveryLoading={deliveryLoading}
          deliveryError={deliveryError}
          onRequestDeliveryAddress={onRequestDeliveryAddress}
        />
      )}
    </>
  );
};

export default GroupedStep2;